import config from './config.js';

export class SaasBlob {
    constructor(saasInfo, x, y, level = 1) {
        this.saasInfo = saasInfo;
        this.x = x;
        this.y = y;
        const sizeMultiplier = 1 + (level - 1) * 0.5; // Increase size by 50% each level
        this.mass = (saasInfo.size || 450) * sizeMultiplier;
        this.radius = Math.sqrt(this.mass / Math.PI) * 10;
        this.speed = 3 + level * 0.75; // Increased from 2 + level * 0.5
        this.direction = Math.random() * 2 * Math.PI;
        this.changeDirectionCounter = 0;
        this.level = level;
        this.state = 'wander'; // New state property
        this.wanderTimer = 0;
        this.targetX = x;
        this.targetY = y;
        this.smoothingFactor = 0.8; // Increased for faster response
        this.wanderAngle = Math.random() * Math.PI * 2;
        this.globalSlowEffect = 1; // New property to track global slow effect
    }

    update(player) {
        const dx = player.x - this.x;
        const dy = player.y - this.y;
        const distance = Math.sqrt(dx * dx + dy * dy);

        const chaseRange = this.radius * (8 + this.level * 1.5);
        const fleeRange = this.radius * (5 + this.level);

        // const randomFactor = Math.random() * 0.3 + 0.85; // Random factor between 0.85 and 1.15

        if (distance < chaseRange) {
            if (this.radius > player.radius) {
                this.state = 'chase';
            } else if (distance < fleeRange) {
                this.state = 'flee';
            } else {
                this.state = 'wander';
            }

        } else {
            this.state = 'wander';
        }

        switch (this.state) {
            case 'chase':
                this.updateTargetPosition(player.x, player.y, 1.0);
                break;
            case 'flee':
                this.updateTargetPosition(player.x, player.y, -1.2);
                break;
            case 'wander':
                this.wander();
                break;
        }

        // Update the global slow effect
        this.globalSlowEffect = player.slowEffect;

        // Smooth movement towards the target position, considering the global slow effect
        const effectiveSmoothing = this.smoothingFactor * this.globalSlowEffect;
        this.x += (this.targetX - this.x) * effectiveSmoothing;
        this.y += (this.targetY - this.y) * effectiveSmoothing;

        // Keep the SaaS blob within game boundaries
        this.x = Math.max(0, Math.min(this.x, config.gameWidth));
        this.y = Math.max(0, Math.min(this.y, config.gameHeight));
    }

    updateTargetPosition(targetX, targetY, speedFactor) {
        const dx = targetX - this.x;
        const dy = targetY - this.y;
        const distance = Math.sqrt(dx * dx + dy * dy);
        const moveDistance = this.speed * speedFactor;
        this.targetX = this.x + (dx / distance) * moveDistance;
        this.targetY = this.y + (dy / distance) * moveDistance;
    }

    wander() {
        this.wanderTimer++;
        if (this.wanderTimer > 60) {
            this.wanderAngle += (Math.random() - 0.5) * Math.PI / 2;
            this.wanderTimer = 0;
        }

        const wanderSpeed = this.speed * 0.3;
        this.targetX = this.x + Math.cos(this.wanderAngle) * wanderSpeed;
        this.targetY = this.y + Math.sin(this.wanderAngle) * wanderSpeed;

        // Bounce off walls
        if (this.targetX <= 0 || this.targetX >= config.gameWidth) {
            this.wanderAngle = Math.PI - this.wanderAngle;
        }
        if (this.targetY <= 0 || this.targetY >= config.gameHeight) {
            this.wanderAngle = -this.wanderAngle;
        }

        // Occasionally make "mistakes" in movement
        if (Math.random() < 0.05) {
            this.targetX += (Math.random() - 0.5) * this.speed * 2;
            this.targetY += (Math.random() - 0.5) * this.speed * 2;
        }
    }
}

